import { SearchX } from "lucide-react";
import { Button } from "@/components/ui/button";

const EmptyState = ({ hasFilters, onClearFilters }) => {
  return (
    <div 
      className="flex flex-col items-center justify-center py-20 text-center"
      data-testid="empty-state"
    >
      <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mb-6">
        <SearchX className="w-10 h-10 text-slate-400" />
      </div>
      <h3 className="text-xl font-semibold text-slate-700 font-['Manrope'] mb-2">
        No use cases found
      </h3>
      <p className="text-slate-500 max-w-md mb-6">
        {hasFilters 
          ? "No use cases match your current filters. Try different keywords or clear your filters."
          : "There are no use cases in the library yet. Add your first use case to get started."
        }
      </p>
      {hasFilters && (
        <Button
          onClick={onClearFilters}
          variant="outline"
          className="border-[#FF6F40] text-[#FF6F40] hover:bg-[#FFF1EC]"
          data-testid="clear-filters-empty-btn"
        >
          Clear all filters
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
